var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",staticClass:"b-role-card",attrs:{"to":_vm.to}},[(_vm.title)?_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("content"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }